import en from './en.json'
import vi from './vi.json'

export default { en, vi }
